import React from 'react';
import { Helmet } from 'react-helmet';


const D3News = () => {
  return (
    <div>
      <Helmet>
        <title>D3 News</title>
      </Helmet>
      <h1>D3 News</h1>

      <p>
        Las noticias internacionales mas relevantes, directamente de la API de los sitios web mas imporantes"
      </p>

      <p></p>
      <a href="/downloads/d3news.apk" download>
        Descargar Instalador (APK)
      </a>

      

      
      
      
    </div>
  );
};

export default D3News;